import router from '@/modules/router';
import { cartActions } from '@/features/Cart/services/cartService';
import { useCartStore } from '@/features/Cart/stores/cart';
import { SECOND_FREE_GIFT_ELIGIBLE_ATTRIBUTE } from '@/features/Cart/cartRules/freeGift';

const SECOND_FREE_GIFT_PARAM = 'vsb_gift';

export const hasSecondFreeGiftLink = (): boolean =>
  new URLSearchParams(window.location.search).has(SECOND_FREE_GIFT_PARAM);

const removeSecondFreeGiftParam = async () => {
  await router.isReady();
  const { path, query, hash } = router.currentRoute.value;
  const remainingQuery = Object.fromEntries(
    Object.entries(query).filter(([key]) => key !== SECOND_FREE_GIFT_PARAM),
  );
  await router.replace({ path, query: remainingQuery, hash });
};

export const handleSecondFreeGiftLink = async (): Promise<void> => {
  if (!hasSecondFreeGiftLink()) return;
  try {
    await removeSecondFreeGiftParam();
    if (!useCartStore().secondFreeGiftOption) return;
    await cartActions().setCartAttributes({ [SECOND_FREE_GIFT_ELIGIBLE_ATTRIBUTE]: 'true' });
  } catch (error) {
    console.error('Failed to process second free gift link:', error);
  }
};
